import template from './jobTypesList.template.html';

export default {
  template,
  bindings: {
    jobTypes: '=',
    labels: '=',
    onClick: '&',
    onChange: '&',
    onLabelsSelect: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = listService;
      ctrl.list.clear();
      ctrl.isAllSelected = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.jobTypes, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };
      this.click = function ($event, data) {
        ctrl.onClick({ event: $event, data: data });
      };
      this.select = function (data) {
        var isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data: data, isSelected: isSelected });
      };
      this.labelsSelect = function ($event, data) {
        ctrl.onLabelsSelect({ event: $event, data: data });
      };
      ctrl.getLabel = function (idLabel) {
        return _.find(ctrl.labels, function (label) {
          return label.id === idLabel;
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.jobTypes && changes.jobTypes.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
